export default {
  // Sao lưu
  Backup: 0,

  // Phục hồi
  Restore: 1,

  /// Lưu trữ
  Store: 2,

  /// Phục hồi lưu trữ
  RestoreStore: 3
};
